import { PessoaListaRequest } from "./pessoa-lista.request";

export class PessoaImpressaoAgrupadaRequest extends PessoaListaRequest {
    public tipoAgrupamento: number;
    public imprimeEndereco: boolean;
}